// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_18266","cover":"_2872","name":"_7235","desc":"_15505","actions":"_13392","cancel":"_16093","confirm":"_18492"};